import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide } from "@mui/material";
import { forwardRef, Fragment, useState } from "react";
import { TransitionProps } from "@mui/material/transitions";
import { CrossIcon } from "../assets/icons";
import Can from "../components/Can";

interface IProps {
  text: string;
  titleIcon: React.ReactNode;
  yes?: string | null;
  no?: string | null;
  permission?: string;
}

export const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useConfirm = (props: IProps): [() => JSX.Element, () => Promise<unknown>] => {
  const [promise, setPromise] = useState<any>(null);

  const confirm = () =>
    new Promise((resolve, reject) => {
      setPromise({ resolve });
    });

  const handleClose = () => {
    setPromise(null);
  };

  const handleConfirm = () => {
    promise?.resolve(true);
    handleClose();
  };

  const handleCancel = () => {
    promise?.resolve(false);
    handleClose();
  };

  const ConfirmationDialog = () => (
    <Fragment>
      <Dialog
        open={promise !== null}
        TransitionComponent={Transition}
        // onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px",
            boxShadow: "0px 12px 24px 0px rgba(0, 0, 0, 0.15)",
            padding: "24px",
            maxWidth: "320px",
          },
          "& .MuiDialogTitle-root": {
            paddingBottom: "16px",
          },
          "& .MuiDialogContent-root,& .MuiDialogActions-root": {
            padding: 0,
          },
          "& .MuiDialogContent-root": {
            color: "text.dark",
            textAlign: "center",
            fontSize: "15px",
            fontWeight: 500,
          },
        }}
      >
        <DialogTitle
          sx={{
            color: "text.dark",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "150%",
          }}
        >
          {props.titleIcon}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "text.dark2",
          }}
        >
          <CrossIcon />
        </IconButton>
        <DialogContent>{props.text}</DialogContent>
        <DialogActions sx={{ marginTop: "16px" }}>
          {props.no === null ? null : (
            <Button fullWidth onClick={handleCancel}>
              {props.no ? props.no : "No"}
            </Button>
          )}

          {props.permission ? (
            <Can permission={props.permission}>
              <Button fullWidth color="secondary" variant="contained" onClick={handleConfirm}>
                {props.yes ? props.yes : "Yes"}
              </Button>
            </Can>
          ) : (
            <Button fullWidth color="secondary" variant="contained" onClick={handleConfirm}>
              {props.yes ? props.yes : "Yes"}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Fragment>
  );
  return [ConfirmationDialog, confirm];
};

export default useConfirm;
